<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<jiezhenList></jiezhenList>
		</div>
		<div class="add" v-if="type==='see'">
			<jiezhenSee></jiezhenSee>
		</div>
	</div>
</template>
<script>
	import jiezhenList from "../comp/jiezhen_list.vue"
	import jiezhenSee from "../comp/jiezhen_see.vue"
	export default {
		components:{jiezhenList,jiezhenSee},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.jiezhenParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
